export default __webpack_public_path__ + "static/s10-5d192f9273892781d90a5b23b9a5dca7.png";